import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useParams } from 'react-router-dom';
import { fetchPlaceDetails } from '../../features/admin/placeSlice';
import { AppDispatch, RootState } from '../../store';
import { AiFillHome } from 'react-icons/ai';
import Loading from '../ui/Loading';
import { useSEO } from '../../custom hooks/useSEO';

const PlacePage = () => {
	const { placeId } = useParams<{ placeId: string }>();
	const { t } = useTranslation();
	const { t: tSeo } = useTranslation("seo");

	const seo = useSEO({
		title: tSeo("placeDetails.title"),
		description: tSeo("placeDetails.description")
	});
	const dispatch = useDispatch<AppDispatch>();
	const { place, loading } = useSelector((state: RootState) => state.placeSlice);
	const { user } = useSelector((state: RootState) => state.user);

	useEffect(() => {
		if (placeId) {
			dispatch(fetchPlaceDetails({ placeId: parseInt(placeId), userId: user?.id }));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [placeId, dispatch, user?.id]);



	if (!place && loading) return <Loading />;

	return (
		<div>
			{seo}
			{/* Header */}
			<div className="green-hero flex-center relative main-prop xs:h-full md:h-[70vh] padding-container">
				<div className="relative z-20 text-white text-center py-10">
					<h1 className="text-4xl font-bold mb-2">{place?.title}</h1>
					<div className="flex items-center justify-center gap-1 text-base">
						<AiFillHome className="mr-1 text-white text-lg" />
						<span>{t('home')}</span>
						<span className="mx-2">/</span>
						<span>{place?.title}</span>
					</div>
				</div>
			</div>

			{/* Content */}
				<Outlet/>
			
		</div>
	);
};

export default PlacePage;
